import { useEffect } from "react";
import { useRemoveCompanyMutation } from "../../../../../API/authApi";
import { useToastify } from "../../../../../Hooks/hooks";

const useDeleteCompanyDialog = (onClose: () => void, cb: () => void) => {
    const [removeCompany, { isLoading, isSuccess, isError }] = useRemoveCompanyMutation();
    const {showToastError} = useToastify();
    const onRemoveCompany = (id: number) => {
        removeCompany(id)
    };

    useEffect(() => {
        if (isSuccess) {
            onClose();
            cb()
        };
    }, [isSuccess]);

    useEffect(() => {
        isError && showToastError('Something went wrong')
    }, [isError]);

    return {
        onRemoveCompany,
        isLoading
    }
};

export default useDeleteCompanyDialog